/*
 * @Author: your name
 * @Date: 2021-03-15 16:06:01
 * @LastEditTime: 2021-08-17 20:46:55
 * @LastEditors: hai.zhang
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-purchase\components\sy-upload\i18n.js
 */
const i18n = {
  'zh-CN': {
    onTheCross: '上传中',
    downLoadTemplate: '下载导入模板文件',
    uploadImportFile: '上传导入文件',
    supportedFormats: '支持{m}格式，大小在{n}以内',
    pleaseSelectAFileAndUploadIt: '请选择文件后上传',
    uploadFailedPleaseReupload: '上传失败，请重新上传',
    uploadFileFormat: '上传文件为{m}格式，大小{n}以内'
  },
  en: {
    onTheCross: 'Uploading',
    downLoadTemplate: 'Download import template file',
    uploadImportFile: 'Upload import file',
    supportedFormats: '{m} format is supported, and the size is less than {n}.',
    pleaseSelectAFileAndUploadIt: 'Please select a file and upload it.',
    uploadFailedPleaseReupload: 'Uploading failed, please try again.',
    uploadFileFormat: '上传文件为{m}格式，大小{n}以内'
  },
  jp: {
  }
}
export default i18n
